import React, { PropTypes } from 'react';
import CollapseContainer from './CollapseContainer';
import Paper from 'material-ui/Paper';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import FontIcon from 'material-ui/FontIcon';

class Collapse extends React.Component {
  static propTypes = {
    label: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired
  };

  state = {
    open: false
  };

  toggleCollapse() {
    this.setState({open: !this.state.open});
  }

  render() {
    let { label, children } = this.props;
    let { open } = this.state;

    return (
      <Paper style={{zIndex: 1}}>
        <Toolbar>
          <ToolbarGroup firstChild={false}>
            <ToolbarTitle text={label} />
          </ToolbarGroup>
          <ToolbarGroup firstChild={false}>
            <FontIcon onClick={() => this.toggleCollapse()} className="material-icons">keyboard_arrow_down</FontIcon>
          </ToolbarGroup>
        </Toolbar>
        <CollapseContainer open={open}>
          <div style={{padding: 15}}>{children}</div>
        </CollapseContainer>
      </Paper>
    );
  }
}

export default Collapse;





// WEBPACK FOOTER //
// ./src/components/Collapse/Collapse.js